<section class="py-3">
  <div class="container-fluid card inner-scroll">
    <div class="pt-3">
      <button type="button" class="btn btn-back mb-2" [routerLink]="'/product-list'">
        <fa-icon [icon]="faArrowLeft" class="me-1"></fa-icon> Back
      </button>
      <h3 class="text strat">
        {{ selectedStockInId ? "Update" : "" }} Product Purchase Information
      </h3>
    </div>
    <form [formGroup]="addOrderOutForm" (ngSubmit)="saveOrderOutData()">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="branchSelect">Branch<span class="text-danger">*</span></label>
          <ng-select labelForId="branchSelect" [items]="filteredActiveBranches" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="false" [searchable]="true" placeholder="Select Branch"
            formControlName="company" class="ng-select-bootstrap" appendTo="body"
            [readonly]="selectedStockInId">
          </ng-select>
          @if (
          addOrderOutForm.get("company")?.invalid &&
          (addOrderOutForm.get("company")?.dirty ||
          addOrderOutForm.get("company")?.touched)
          ) {
          <div class="errorText">
            @if (addOrderOutForm.get("company")?.errors?.["required"]) {
            <div>
              <small class="text-danger">Select Branch Type</small>
            </div>
            }
          </div>
          }
        </div>
        }

        <div class="col-12 col-sm-6 col-md-3">
          <label for="dealerSelect">Dealer<span class="text-danger">*</span></label>
          <ng-select labelForId="dealerSelect" [items]="dealerList" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="false" [searchable]="true" placeholder="Search or Select Dealer"
            formControlName="dealer" class="ng-select-bootstrap" appendTo="body"
            [readonly]="selectedStockInId" [searchFn]="customSearchFn"
            (search)="onDealerInputChange($event)" (scrollToEnd)="scrollDealer()">
          </ng-select>
          @if (
          addOrderOutForm.get("dealer")?.invalid &&
          (addOrderOutForm.get("dealer")?.dirty ||
          addOrderOutForm.get("dealer")?.touched)
          ) {
          <div class="errorText">
            @if (addOrderOutForm.get("dealer")?.errors?.["required"]) {
            <div>
              <small class="text-danger">Select Dealer</small>
            </div>
            }
          </div>
          }
        </div>
      </div>

      @for (item of stock.controls; track item; let i = $index) {
      <div formArrayName="stock">
        <div class="row pt-3 g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreSizeSelect_' + i">Tyre Size<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'tyreSizeSelect_' + i" [items]="tyreSizeObj.list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Size"
              formControlName="tyreSize" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="selectedStockInId" (change)="onOptionsSelected($event?.tyreSize, i)"
              (scrollToEnd)="onScrollTyreSize()" (search)="onTyreSizeInputChange($event)"
              (close)="onSizeClose()" (clear)="onSizeClose()">
            </ng-select>
            @if (
            $any(stock).controls[i].controls["tyreSize"].invalid &&
            ($any(stock).controls[i].controls["tyreSize"]?.dirty ||
            $any(stock).controls[i].controls["tyreSize"].touched)
            ) {
            <div class="errorText">
              @if (
              $any(stock).controls[i].controls["tyreSize"].errors?.[
              "required"
              ]
              ) {
              <div>
                <small class="text-danger">Select Tyre Size</small>
              </div>
              }
            </div>
            }
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreMakeSelect_' + i">Tyre Make<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'tyreMakeSelect_' + i" [items]="tyreMakeObj.list" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Make"
              formControlName="tyreMake" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="selectedStockInId" (change)="selectMake($event, i)" (search)="onTyreMakeInputChange($event)"
              (close)="onMakeClose()" (clear)="onMakeClose()">
            </ng-select>
            @if (
            $any(stock).controls[i].controls["tyreMake"].invalid &&
            ($any(stock).controls[i].controls["tyreMake"]?.dirty ||
            $any(stock).controls[i].controls["tyreMake"].touched)
            ) {
            <div class="errorText">
              @if (
              $any(stock).controls[i].controls["tyreMake"].errors?.[
              "required"
              ]
              ) {
              <div>
                <small class="text-danger">Select Tyre Make</small>
              </div>
              }
            </div>
            }
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
            <ng-select [labelForId]="'tyreModelSelect_' + i" [items]="modelList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Model"
              formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="selectedStockInId || !stock.at(i).get('tyreMake')?.value" (change)="getFreightDetails(i)"
              (scrollToEnd)="scroll(i)" (search)="onTyreModelInputChange($event, i)"
              (close)="onModelClose(i)" (clear)="onModelClose(i)">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'quantityInput_' + i">Total Quantity<span class="text-danger">*</span></label>
            <input [id]="'quantityInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="quantity"
              name="quantity" required placeholder="Quantity" [appMaxLength]="10" appBlockNumberSpecialchars [extraChars]="['.']" />
            @if (
            $any(stock).controls[i].controls["quantity"].invalid &&
            ($any(stock).controls[i].controls["quantity"]?.dirty ||
            $any(stock).controls[i].controls["quantity"].touched)
            ) {
            <div>
              <small class="text-danger">Quantity is required</small>
            </div>
            }
            @if (
            $any(stock).controls[i].controls["quantity"].value &&
            $any(stock).controls[i].controls["purchasingPrice"].value &&
            +$any(stock).controls[i].controls["quantity"].value > +$any(stock).controls[i].controls["purchasingPrice"].value &&
            ($any(stock).controls[i].controls["quantity"]?.touched ||
            $any(stock).controls[i].controls["purchasingPrice"]?.touched)
            ) {
            <div>
              <small class="text-warning"><span class="fw-bold">Double-check:</span> The quantity is higher than the unit price.</small>
            </div>
            }
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'pricePerTyreInput_' + i">Price Per Tyre<span class="text-danger">*</span></label>
            <input [id]="'pricePerTyreInput_' + i" type="number" class="form-control no-spinner default-form-group-border" [appMaxLength]="10"
              formControlName="purchasingPrice" required placeholder="Unit Price" appBlockNumberSpecialchars />
            @if (
            $any(stock).controls[i].controls["purchasingPrice"].invalid &&
            ($any(stock).controls[i].controls["purchasingPrice"]?.dirty ||
            $any(stock).controls[i].controls["purchasingPrice"].touched)
            ) {
            <div>
              <small class="text-danger">Price is required</small>
            </div>
            }
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <div class="amount">
              <label [attr.for]="'minAmountInput_' + i">Min Sale Price</label>
              <input [id]="'minAmountInput_' + i" type="number" class="form-control no-spinner default-form-group-border" [appMaxLength]="10"
                formControlName="minAmount"  placeholder="Min" [readOnly]="selectedStockInId" appBlockNumberSpecialchars />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <div class="amount">
              <label [attr.for]="'maxAmountInput_' + i">Max Sale Price</label>
              <input [id]="'maxAmountInput_' + i" type="number" class="form-control no-spinner default-form-group-border" [appMaxLength]="10"
                formControlName="maxAmount"  placeholder="Max" [readOnly]="selectedStockInId" appBlockNumberSpecialchars/>
            </div>
          </div>
          <div class="col-6 col-sm-3 col-md-2 text-center">
            <div class="amount">
              <span class="text-muted">Average Sale Price</span>
              <p class="amount-value pt-2">
                {{ priceDetailsArray[i].avgPrice || "-" }}
              </p>
            </div>
          </div>
          <div class="col-6 col-sm-3 col-md-1 d-flex align-items-end justify-content-start">
              @if (i == stock.length - 1) {
              <button class="btn app-btn-primary me-1" type="button" (click)="addItem(i)" [disabled]="selectedStockInId">
                <fa-icon [icon]="faPlus" class="fa-1x"></fa-icon>
              </button>
              }
              @if (stock.length > 1) {
              <button class="btn btn-danger" type="button" (click)="removeItem(i)"[disabled]="selectedStockInId">
                <fa-icon [icon]="faTrash" class="fa-1x"></fa-icon>
              </button>
              }
          </div>
        </div>
      </div>
      }

      <div class="row pt-3 g-3">
        <div class="col-12 col-sm-6 col-md-3">
          <div class="d-flex align-items-center gap-2 pt-3">
            <input class="form-check-input mt-0" type="checkbox" id="withInvoice" formControlName="isUploadInvoiceCheckbox" (change)="onInvoiceCheckboxChange($event)" style="cursor: pointer;" [attr.disabled]="editParamMode === 'editId' ? true : null" />
            <label class="form-check-label fw-bold mb-0" for="withInvoice" style="cursor: pointer; line-height: 1;">With Invoice</label>
          </div>
          @if (showUploadForm) {
            @if (isEditStock && addOrderOutForm.get('invoice')?.value) {
              <div class="form-control default-form-group-border mt-2" style="background-color: #e9ecef !important; color: #495057; cursor: not-allowed; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                Uploaded Invoce
              </div>
            } @else {
              <input type="file" class="form-control default-form-group-border mt-2" id="invoiceFile"
                formControlName="invoiceFile" accept="application/pdf,.pdf,.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                (change)="onFileSelected($event)" />
            }
          }
        </div>
        @if (showUploadForm) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="invoiceNumber">Invoice Number</label>
          <input formControlName="invoiceNumber" id="invoiceNumber" type="text" maxlength="30"
            class="form-control default-form-group-border" placeholder="Invoice number" />
        </div>
        }
        @if (showUploadForm) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="invoiceDateInput">Invoice Date</label>
          <div class="input-group">
            <input type="date" id="invoiceDateInput" class="form-control form-input default-form-group-border" #invoiceDate
              formControlName="invoiceDate" [max]="todayDate" />
          </div>
          @if (
          addOrderOutForm.get("invoiceDate")?.invalid &&
          (addOrderOutForm.get("invoiceDate")?.dirty ||
          addOrderOutForm.get("invoiceDate")?.touched)
          ) {
          <div class="errorText">
            @if (addOrderOutForm.get("invoiceDate")?.errors?.["futureDate"]) {
            <div>
              <small class="text-danger">Future date is not allowed for Invoice Date</small>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      
      @if (showEditReasonField) {
      <div class="row pt-3 g-3">
        <div class="col-12 col-md-6">
          <label for="editReasonTextarea">Reason for Edit<span class="text-danger">*</span></label>
          <textarea id="editReasonTextarea" formControlName="editReason" rows="2" class="form-control default-form-group-border"
            placeholder="Please provide a reason for editing this transaction"></textarea>
          @if (
          addOrderOutForm.get("editReason")?.invalid &&
          addOrderOutForm.get("editReason")?.touched
          ) {
          <div>
            <small class="text-danger">Reason for edit is required</small>
          </div>
          }
        </div>
      </div>
      }

      <div class="row pt-3">
        @if (responseMsg) {
        <div class="alert alert-danger d-flex align-items-start justify-content-between gap-2 mt-2" role="alert">
          <span>{{ responseMsg }}</span>
          <button type="button" class="btn-close flex-shrink-0" aria-label="Close" (click)="responseMsg = ''"></button>
        </div>
        }
        <div class="col-12 text-end p-3">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/product-list'">
            Cancel
          </button>
          <button type="submit" [disabled]="addOrderOutForm.invalid" class="btn app-btn-primary">
            {{ selectedStockInId ? "Update" : "Submit" }}
            @if (isLoading) {
            <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>

    </form>
  </div>
</section>
